import styled from "styled-components";

export const DropdownContainer = styled.div`
  display: inline-block;

  .dropdown-toggle {
    display: inline-block;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.text.primary};
    border: none;
    transition:
      background-color 0.3s ease,
      color 0.3s ease;
    cursor: pointer;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .dropdown_menu {
    font-size: 14px;
    padding: 10px;
    background-color: ${({ theme }) => theme.colors.background.primary};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 8px;
    box-shadow: ${({ theme }) => theme.colors.shadow.sm};
    margin-top: 8px;

    .dropdown-item {
      padding: 10px 16px;
      border-radius: 4px;
      transition: background-color 0.3s ease;

      &:hover {
        color: #fff;
        background-color: ${({ theme }) => theme.colors.background.infoLight};
      }
    }
  }
`;
